export default "/images/32239db3750aee27b91d22fb59a79ea0.avif";